import { BreakdownSTOHeader } from 'modules/intelligentInsights/stoInsights/STO.styles';
import { BREAKDOWN_BY_CHANNEL } from 'modules/intelligentInsights/stoInsights/constants';
import { FlexSpacer } from 'ui/flexSpacer';

export const STO_BREAKDOWN_HEADER_TEST_ID = 'sto-insights-breakdown-header';

export const STOBreakdownHeader = () => {
  return (
    <FlexSpacer justifyContent="flex-start" data-test={STO_BREAKDOWN_HEADER_TEST_ID} width="100%">
      <BreakdownSTOHeader id={STO_BREAKDOWN_HEADER_TEST_ID}>
        {BREAKDOWN_BY_CHANNEL}
      </BreakdownSTOHeader>
    </FlexSpacer>
  );
};
